module.exports = __webpack_public_path__ + "static/14-full-half-circles-994c78d119c6cf2266154748b9d5b352.png";